import { Component, Output, EventEmitter, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-pending',
  templateUrl: './user-pending.component.html',
  styleUrls: ['./user-pending.component.scss']
})

export class UserPendingComponent {
  @Input() userId!: string;
  @Input() userName!: string;
  @Output() cancel = new EventEmitter();
  uri = environment.url;
  showPopup: boolean = false;
  constructor(private http: HttpClient){}

onLinkClick(event: Event): void {
  event.preventDefault();
  this.http.get(this.uri + `/resend/${this.userId}/${this.userName}`).subscribe({
    next: () => {
      this.showPopup = true;

      // Ocultar el popup después de 3 segundos
      setTimeout(() => {
        this.showPopup = false;
      }, 3000);
    },
    error: (err) => {
      console.error('Error al reenviar el correo:', err);
    }
  });
}


  onCancel() {
    this.cancel.emit();
  }
}
